module.exports = __webpack_public_path__ + "img/loading2.2c3e839c.svg";